import {
  EDGELESS_DND_PREVIEW_ELEMENT,
  EdgelessDndPreviewElement,
} from './components/edgeless-preview/preview';
import { HIVE_DRAG_HANDLE_WIDGET } from './consts';
import { HiveDragHandleWidget } from './drag-handle';

export function effects() {
  customElements.define(HIVE_DRAG_HANDLE_WIDGET, HiveDragHandleWidget);
  customElements.define(
    EDGELESS_DND_PREVIEW_ELEMENT,
    EdgelessDndPreviewElement
  );
}
